<script lang="ts">
  import { onMount } from 'svelte'
  import { onDestroy } from 'svelte'
  import { AnimationTimer } from '../api/animationTimer'

  export let onCanvas: (canvas:HTMLCanvasElement) => void
  export let onRender: (ctx:CanvasRenderingContext2D) => void
  export let canvasWidth:number
  $: if (!Number.isNaN(canvasWidth)) {
    canvasSizeChanged = true
  }
  export let canvasHeight:number
  $: if (!Number.isNaN(canvasHeight)) {
    canvasSizeChanged = true
  }
  let canvasSizeChanged:boolean = false
  let canvas:HTMLCanvasElement
  let ctx:CanvasRenderingContext2D
  let animationTimer:AnimationTimer = new AnimationTimer(()=> { onAnimationFrame() })

  let clientWidth:number = Number.NaN
  let clientHeight:number = Number.NaN
  let ratio:number = Number.NaN

  onMount(() => {
    ctx = canvas.getContext('2d') as CanvasRenderingContext2D
    animationTimer.start()
    if (onCanvas) { onCanvas(canvas) }
	})

  onDestroy(() => {
    animationTimer.stop()
  })

  function onAnimationFrame() {
    if (
        canvasSizeChanged ||
        canvas.clientWidth != clientWidth ||
        canvas.clientHeight != clientHeight
      ) {
      canvasSizeChanged = false

      clientWidth = canvas.clientWidth;
      clientHeight = canvas.clientHeight;

      const widthRatio:number = clientWidth / canvasWidth;
      const heightRatio:number = clientHeight / canvasHeight;

      ratio = widthRatio < heightRatio ? widthRatio : heightRatio;

      const devicePixelRatio = window.devicePixelRatio || 1;
      ratio = ratio * devicePixelRatio;

      canvas.width = canvasWidth * ratio;
      canvas.height = canvasHeight * ratio;

      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.scale(ratio, ratio);
    }

    //Custom drawing code
    if (onRender) {
      onRender(ctx)
    }

    //Border
    /*const showCanvasSize = true;
    if (showCanvasSize) {
      ctx.beginPath()
      ctx.lineWidth = 1
      ctx.strokeStyle = "black"
      ctx.rect(0, 0, canvasWidth, canvasHeight)
      ctx.stroke()
    }*/
  }
</script>

<canvas bind:this={canvas} width={canvasWidth} height={canvasHeight} class="object-contain flex-1 min-h-0"/>